<app-modal [dismissable]="false" [title]="'Disclaimer' | translate">
  <div ngbAutoFocus class="modal-content ps-2">
    <p>
      La domanda di iscrizione è riservata esclusivamente ai titolari di imprese regolarmente registrate nel settore
      odontoiatrico,
      in particolare dentisti, studi odontoiatrici e cliniche dentali, e in possesso di regolare licenza e degli altri
      requisiti richiesti.
    </p>
    <p>
      Saranno effettuate verifiche approfondite, incluse ispezioni, per garantire la conformità.
      L'iscrizione non garantisce automaticamente la pubblicazione, che è subordinata alla valutazione discrezionale del
      nostro team,
      il quale si riserva il diritto di approvare o rifiutare la richiesta.
    </p>
    <p>
      Le richieste provenienti da agenzie, agenti, call center, intermediari, privati o altre entità non riconducibili
      a professionisti del settore odontoiatrico legalmente registrati non saranno prese in considerazione.
    </p>
    <p>
      Il portale Dental tour funge esclusivamente da intermediario per facilitare il contatto tra dentista e paziente.
    </p>
    <p>
      Nel caso in cui la richiesta venga approvata, Dental tour Sh.P.k non si assume alcuna responsabilità riguardo alla
      veridicità delle informazioni fornite
      né per eventuali problematiche, disaccordi o questioni relative ai servizi offerti, ai pagamenti o ad altri
      aspetti della relazione tra dentista e paziente,
      che restano di esclusiva responsabilità delle parti coinvolte.
    </p>


    <div class="form-check d-flex justify-content-start gap-2">
      <input class="form-check-input" type="checkbox" id="acceptDisclaimer" [(ngModel)]="isChecked">
      <label class="form-check-label" for="acceptDisclaimer">
        {{ 'I confirm that i meet all the eligibility requirements stated in the disclaimer.' | translate }}
      </label>
    </div>

  </div>

  <div class="modal-actions w-100 d-flex align-items-center justify-content-between mt-4 gap-2">
    <button type="button" class="btn btn-secondary" id="declineBtn" (click)="decline()">
      {{ 'Decline' | translate }}
    </button>

    <button type="button" class="btn btn-primary" id="acceptBtn" (click)="activeModal.close()" [disabled]="!isChecked">
      {{ 'Start' | translate }}
    </button>
  </div>

</app-modal>